import React, { Component } from 'react';
import { Dropdown, Input, Divider, Button } from 'semantic-ui-react';
import _ from 'lodash';

import targetingLanguagesValues from '../../components/common/TargetingLanguages';
import publisherPositionsValues from '../../components/common/PublisherPositions';
import {
  optimizationGoalsValues,
  conversionsObjectiveGoalOptions
} from '../../components/common/OptimizationGoals';
import devicesValues from '../../components/common/Devices';
import './ModalAdSet.css';

class ModalAdSet extends Component {
  state = {
    targetingLanguages: targetingLanguagesValues,
    publisherOptions: publisherPositionsValues,
    devicesOptions: devicesValues,
    optimizationGoalOptions:
      optimizationGoalsValues[this.props.objective] ||
      conversionsObjectiveGoalOptions,
    selectedLanguages: '',
    selectedPositions: [
      'Facebook',
      'Instagram',
      'Messenger',
      'audience_network'
    ],
    selectedDevices: ['Desktop', 'Mobile'],
    selectedAudiences: [],
    form: {
      id: null,
      title: '',
      placement: '',
      languages: [],
      positions: publisherPositionsValues,
      devices: devicesValues,
      gender: 0,
      ageFrom: 18,
      ageTo: 65,
      optimizationGoal:
        this.props.objective !== 'VIDEO_VIEWS'
          ? 'OFFSITE_CONVERSIONS'
          : 'THRUPLAY',
      audiences: []
    }
  };

  componentDidMount() {
    if (this.props.adsetToEdit) {
      this.initializeEdit(this.props.adsetToEdit);
    }
  }

  initializeEdit = (adsetToEdit) => {
    const {
      id,
      languages,
      positions,
      devices,
      gender,
      ageFrom,
      ageTo,
      optimizationGoal,
      selectedAudiences = []
    } = adsetToEdit;
    const nameParts = adsetToEdit.adSetName.split('_');
    const selectedLanguages =
      languages && languages.length > 0
        ? languages.map((language) => language.value)
        : [];
    const selectedPositions =
      positions && positions.length > 0
        ? positions.map((position) => position.value)
        : [];
    const selectedDevices =
      devices && devices.length > 0
        ? devices.map((device) => device.value)
        : [];
    const form = {
      ...this.state.form,
      id,
      title: nameParts[nameParts.length - 2],
      placement: nameParts[nameParts.length - 1],
      languages: languages || [],
      positions: positions || [],
      devices: devices || [],
      gender,
      optimizationGoal,
      ageFrom: parseInt(ageFrom, 10),
      agetTo: parseInt(ageTo, 10),
      audiences:
        selectedAudiences && selectedAudiences.length > 0
          ? selectedAudiences.map((audience) => audience.value)
          : []
    };

    this.setState({
      ...this.state,
      form,
      selectedLanguages,
      selectedPositions,
      selectedDevices,
      selectedAudiences
    });
  };

  saveAdSet = () => {
    const { campaignName } = this.props;
    const { selectedAudiences, form } = this.state;
    const {
      id,
      title,
      placement,
      gender,
      ageFrom,
      ageTo,
      optimizationGoal,
      languages,
      positions,
      devices
    } = form;

    const adset = {
      id,
      adSetName: `${campaignName}_${title}_${placement}`,
      gender,
      ageFrom,
      ageTo,
      optimizationGoal,
      languages,
      positions,
      devices,
      selectedAudiences
    };

    this.props.addAdset(adset);
  };

  handleFormChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  onGenderSelect = (value) => {
    const form = this.state.form;
    form.gender = value;
    this.setState({ form });
  };

  onOptionSelect = (e, data) => {
    const languages = [];

    data.value.forEach((val) => {
      const language = _.find(data.options, (option) => {
        return option.value === val;
      });

      if (language) {
        languages.push(language);
      }
    });

    const form = this.state.form;
    form[data.id] = languages;

    this.setState({ form, [data.name]: data.value });
  };

  onAgeSelect = (event, data) => {
    const ageAdset = data.id;
    const age = _.find(data.options, (option) => {
      return option.value === data.value;
    });

    const form = this.state.form;

    form[ageAdset] = age.value;

    this.setState({ form });
  };

  onOptimizationGoalSelect = (event, data) => {
    const optimizationGoal = _.find(data.options, (option) => {
      return option.value === data.value;
    });

    const form = this.state.form;
    form.optimizationGoal = optimizationGoal.value;

    this.setState({ form });
  };

  onAudienceSelectAdset = async (event, { value, options }) => {
    const audiences = [];

    value.forEach((val) => {
      const audience = _.find(options, (option) => {
        return option.value === val;
      });

      if (audience) {
        audiences.push(audience);
      }
    });

    const formAudiences = value;

    this.setState({
      ...this.state,
      selectedAudiences: audiences,
      form: { ...this.state.form, audiences: formAudiences }
    });
  };

  render() {
    const ageOptions = [];
    for (let i = 13; i < 66; i += 1) {
      if (i === 65) {
        ageOptions.push({ key: i, value: i, text: '65+' });
      } else {
        ageOptions.push({ key: i, value: i, text: i });
      }
    }
    const {
      selectedLanguages,
      targetingLanguages,
      selectedPositions,
      publisherOptions,
      selectedDevices,
      devicesOptions,
      optimizationGoalOptions,
      form
    } = this.state;
    const {
      title,
      placement,
      gender,
      ageFrom,
      ageTo,
      optimizationGoal,
      audiences
    } = form;
    const { isHecCampaign, onCloseModalAdset, audienceOptions } = this.props;

    return (
      <div className="modal-adset-container">
        <Input
          className="modal-adset-title"
          placeholder="Title"
          type="text"
          name="title"
          value={title}
          onChange={this.handleFormChange}
        />
        <Input
          placeholder="Placement"
          type="text"
          name="placement"
          value={placement}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <Dropdown
          placeholder="Publisher Positions"
          search
          selection
          id="positions"
          name="selectedPositions"
          multiple
          value={selectedPositions}
          className="modal-adset-multiple-select"
          options={publisherOptions}
          onChange={this.onOptionSelect}
        />
        <Divider hidden />
        <Dropdown
          placeholder="Targeting Languages"
          search
          selection
          id="languages"
          name="selectedLanguages"
          multiple
          value={selectedLanguages}
          className="modal-adset-multiple-select"
          options={targetingLanguages}
          onChange={this.onOptionSelect}
        />
        <Divider hidden />
        <Button.Group>
          <Button
            disabled={isHecCampaign}
            active={gender === 0}
            onClick={() => {
              this.onGenderSelect(0);
            }}
          >
            All
          </Button>
          <Button
            disabled={isHecCampaign}
            active={gender === 1}
            onClick={() => {
              this.onGenderSelect(1);
            }}
          >
            Male
          </Button>
          <Button
            disabled={isHecCampaign}
            active={gender === 2}
            onClick={() => {
              this.onGenderSelect(2);
            }}
          >
            Female
          </Button>
        </Button.Group>
        <Divider hidden />
        <Dropdown
          placeholder="Device Platforms"
          search
          selection
          id="devices"
          name="selectedDevices"
          multiple
          value={selectedDevices}
          className="modal-adset-multiple-select"
          options={devicesOptions}
          onChange={this.onOptionSelect}
        />
        <Divider hidden />
        <Dropdown
          disabled={isHecCampaign}
          className="modal-adset-age-select"
          placeholder="Age From"
          search
          id="ageFrom"
          selection
          value={ageFrom}
          options={ageOptions}
          onChange={this.onAgeSelect}
        />
        <Dropdown
          disabled={isHecCampaign}
          className="modal-adset-age-select"
          placeholder="Age To"
          search
          id="ageTo"
          selection
          value={ageTo}
          options={ageOptions}
          onChange={this.onAgeSelect}
        />
        <Divider hidden />
        <Dropdown
          placeholder="Optimization Goal"
          search
          id="optimizationGoal"
          selection
          value={optimizationGoal}
          options={optimizationGoalOptions}
          onChange={this.onOptimizationGoalSelect}
        />
        <Divider hidden />
        <Dropdown
          placeholder="Audiences"
          search
          multiple
          selection
          name="audiences"
          className="launch-package-audiences"
          value={audiences}
          options={audienceOptions}
          onChange={this.onAudienceSelectAdset}
        />
        <Divider hidden />
        <Button onClick={onCloseModalAdset} size="small" color="grey">
          Cancel
        </Button>
        <Button onClick={this.saveAdSet} size="small" color="blue">
          Save
        </Button>
      </div>
    );
  }
}

export default ModalAdSet;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/ModalAdSet.js